import { render, staticRenderFns } from "./TablaPedido.vue?vue&type=template&id=3e8c0612"
import script from "./TablaPedido.vue?vue&type=script&lang=js"
export * from "./TablaPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports